export default __webpack_public_path__ + "static/media/format_list_numbered_rtl.77ad6624.svg";